import http from '../../utils/httpService';
import { LANGS_ROUTE } from './constants';

/**
 *
 */
const requestLangs = () => (
    http.request( LANGS_ROUTE, 'GET' )
);

export {
    requestLangs
};

